import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import "../../../../../app/src/Components/widget_v2/carousel.css";
import { trackEdgeFade } from "./edgeFade";

// Flechas de los carruseles de widgets: redondas y aparecen al pasar el ratón (estilos en widget_v2/carousel.css).

// Props para MobileScrollCarousel; se ponen después de las del widget para que prevalezcan.
export const mobileCarouselArrowsProps = { className: "mobile-scroll-v2", arrowBottom: "2rem", fadeImages: true };

// El Carousel la renderiza como customButtonGroup en cada cambio de estado; no pinta nada, solo comunica
// hacia qué lados se puede desplazar (mismas condiciones que usa la librería para sus flechas) y guarda
// previous/next para las flechas propias.
const CarouselEdges = ({ carouselState, previous, next, infinite, actionsRef, onEdgesChange }) => {
  const { currentSlide = 0, totalItems = 0, slidesToShow = 0 } = carouselState || {};
  const enoughChildren = slidesToShow > 0 && totalItems >= slidesToShow;
  const canScrollLeft = enoughChildren && (infinite || currentSlide > 0);
  const canScrollRight = enoughChildren && (infinite || currentSlide + slidesToShow < totalItems);

  actionsRef.current = { previous, next };

  useEffect(() => {
    onEdgesChange(canScrollLeft, canScrollRight);
  }, [canScrollLeft, canScrollRight, onEdgesChange]);

  return null;
};

// Las imágenes de los items se desvanecen hacia los bordes de carousel-v2-fade (ver edgeFade.js); las
// flechas se pintan aparte, con las mismas clases que las de la librería.
const FadeCarousel = ({ children, textOverImage }) => {
  const carousel = React.Children.only(children);
  const actionsRef = useRef({});
  const fadeBoxRef = useRef(null);

  const [edges, setEdges] = useState({ left: false, right: false });

  useLayoutEffect(() => trackEdgeFade(fadeBoxRef.current), []);

  const onEdgesChange = useCallback((left, right) => {
    setEdges((prev) => (prev.left === left && prev.right === right ? prev : { left, right }));
  }, []);

  const className = [
    edges.left && "can-scroll-left",
    edges.right && "can-scroll-right",
    textOverImage && "text-over-image",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div id="carousel_v2" className={className}>
      <div ref={fadeBoxRef} className="carousel-v2-fade edge-fade-box">
        {React.cloneElement(carousel, {
          arrows: false,
          renderButtonGroupOutside: true,
          customButtonGroup: (
            <CarouselEdges
              infinite={!!carousel.props.infinite}
              actionsRef={actionsRef}
              onEdgesChange={onEdgesChange}
            />
          ),
        })}
      </div>
      {edges.left && (
        <button
          type="button"
          aria-label="Go to previous slide"
          className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left"
          onClick={() => actionsRef.current.previous?.()}
        />
      )}
      {edges.right && (
        <button
          type="button"
          aria-label="Go to next slide"
          className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right"
          onClick={() => actionsRef.current.next?.()}
        />
      )}
    </div>
  );
};

// Envuelve el Carousel de escritorio para aplicarle las flechas nuevas. textOverImage: los items tienen
// texto encima de la imagen (ver edgeFade.css).
export const CarouselArrows = ({ children, textOverImage = false }) => (
  <FadeCarousel textOverImage={textOverImage}>{children}</FadeCarousel>
);
